var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 25.4222L21.875 0.422241H28.125L46.875 25.4222L28.125 50.4222H21.875L3.125 25.4222Z",
    fill: "#070707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.422241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDiamond);
export default __webpack_public_path__ + "static/media/home-diamond.6dc218381a430533ea9db58645104b11.svg";
export { ForwardRef as ReactComponent };